const fullscreenNavigation = {
    isOpen: false,
    currentActive: null,
};

function toggleClass(element, className, addClass) {
    if (addClass) {
        element.classList.add(className);
    } else {
        element.classList.remove(className);
    }
}

function getNextSiblingWithClass(element, className) {
    let sibling = element.nextElementSibling;
    while (sibling) {
        if (sibling.classList.contains(className)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
    //if no sibling, check siblings of parent element
    if (element.parentElement) {
        return getNextSiblingWithClass(element.parentElement, className);
    }
    return null;
}

function handleNavToggle(e) {
    document
        .querySelectorAll(".webx-child-link, .webx-grandchild-link")
        .forEach((link) => {
            link.classList.remove("active");
        });
    document.querySelectorAll(".webx-full-screen-overlay").forEach((item) => {
        item.classList.remove("active");
    });
    //set isOpen to true
    fullscreenNavigation.isOpen = true;
    e.preventDefault();

    //get .webx-close-wrapper.mobile and add class back-button
    const backWrapper = document.querySelector(".webx-close-wrapper.mobile");
    //if window width is above add back button
    backWrapper.classList.add("back-button");
    //if body has class webx-fullscreen-nav-open, all good, otherwise add it
    document.body.classList.add("webx-fullscreen-nav-open");
    if (fullscreenNavigation.isOpen) {
        fullscreenNavigation.currentActive = e.target.dataset.navid;
        const sibling = getNextSiblingWithClass(
            e.target,
            "webx-full-screen-overlay",
        );
        toggleActiveSubMenu(sibling);
    } else {
        fullscreenNavigation.currentActive = null;
        toggleActiveSubMenu(null);
    }
}

function toggleActiveSubMenu(submenu) {
    document.querySelectorAll(".webx-full-screen-overlay").forEach((item) => {
        toggleClass(item, "active", item === submenu);
    });
}

function handleLinkClick(e) {
    let linkElement = e.target;

    //so sorry bout that, but the logic here changed a million times according to new requirements
    if (
        e.target.tagName === "A" ||
        e.target.classList.contains("child-nav-arrow")
    ) {
        linkElement = e.target.parentElement;
    }
    if (e.target.tagName === "svg") {
        linkElement = e.target.parentElement.parentElement;
    }
    if (linkElement.dataset.navigable === "true") {
        //check if ctrl key is pressed
        if (e.ctrlKey) {
            e.stopPropagation();
            return;
        }

        return;
    }

    e.preventDefault();
    e.stopPropagation();

    const linkType = linkElement.classList.contains("webx-child-link")
        ? "child"
        : "grandchild";
    const linksToDisable =
        linkType === "child"
            ? [".webx-child-link", ".webx-grandchild-link"]
            : [".webx-grandchild-link"];

    document.querySelectorAll(linksToDisable.join(",")).forEach((link) => {
        link.classList.remove("active");
    });
    linkElement.classList.add("active");
}

document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelectorAll(".top-nav, .top-arrow-wrapper")
        .forEach((item) => {
            item.addEventListener("click", handleNavToggle);
        });

    document
        .querySelectorAll(
            ".webx-child-link, .webx-grandchild-link, .webx-greatgrandchild-link",
        )
        .forEach((link) => {
            link.addEventListener("click", handleLinkClick);
            link.addEventListener("keypress", function (e) {
                //if enter key is pressed
                if (e.key === "Enter") {
                    handleLinkClick(e);
                }
            });
        });

    document.addEventListener("keyup", function (e) {
        if (e.key === "Escape" && fullscreenNavigation.isOpen) {
            handleNavToggle({
                preventDefault: () => {},
                target: { dataset: { navid: null } },
            });
            fullscreenNavigation.isOpen = false;
            document.body.classList.remove("webx-fullscreen-nav-open");
        }
    });

    document.querySelectorAll(".switcher-button").forEach((button) => {
        button.addEventListener("click", function () {
            //get parent element
            const parent = this.parentElement;
            //toggle class active
            parent.classList.toggle("active");
        });
    });
});

// // if resize below or above 1280px, reset menu completely
// window.addEventListener("resize", function () {
//     if (window.innerWidth > 1280) {
//         document
//             .querySelectorAll(
//                 ".webx-child-link, .webx-grandchild-link, .webx-greatgrandchild-link",
//             )
//             .forEach((link) => {
//                 link.classList.remove("active");
//                 document.body.classList.remove("webx-fullscreen-nav-open");
//                 document
//                     .querySelector(".wp-block-webx-blocks-full-screen-menu")
//                     .classList.remove("visible");
//                 document
//                     .querySelectorAll(".webx-full-screen-overlay")
//                     .forEach((item) => {
//                         item.classList.remove("active");
//                     });

//                 fullscreenNavigation.isOpen = false;
//                 fullscreenNavigation.currentActive = null;
//             });
//     }
// });

//add click listener to webx-hamburger-icon and toggle the webx-fullscreen-nav-open class on body and add visible to wp-block-webx-full-screen-menu
document.addEventListener("DOMContentLoaded", function () {
    document
        .querySelector(".webx-hamburger-menu")
        .addEventListener("click", function () {
            this.classList.toggle("open");
            //if the webx-fullscreen-nav-open class is present, remove it, otherwise add it
            document.body.classList.toggle("webx-fullscreen-nav-open");
            document
                .querySelector(".wp-block-webx-blocks-full-screen-menu")
                .classList.toggle("visible");
            //setting the isOpen to true
            fullscreenNavigation.isOpen = true;
        });
    document
        .querySelectorAll(".webx-full-screen-overlay")
        .forEach((wrapper) => {
            wrapper.addEventListener("click", function () {
                document
                    .querySelectorAll(
                        ".webx-child-link, .webx-grandchild-link, .webx-greatgrandchild-link",
                    )
                    .forEach((link) => {
                        link.classList.remove("active");
                        document.body.classList.toggle(
                            "webx-fullscreen-nav-open",
                        );
                    });
                document
                    .querySelector(".wp-block-webx-blocks-full-screen-menu")
                    .classList.remove("visible");
                document.body.classList.remove("webx-fullscreen-nav-open");
                document
                    .querySelectorAll(".webx-full-screen-overlay")
                    .forEach((item) => {
                        item.classList.remove("active");
                    });

                fullscreenNavigation.isOpen = false;
                fullscreenNavigation.currentActive = null;
            });
        });

    document
        .querySelectorAll(".webx-close-wrapper.mobile")
        .forEach((wrapper) => {
            wrapper.addEventListener("click", function () {
                //the current wrapper always has a sibling webx-child-menu.
                let closed = false;
                //check all webx-grandchild links in webx-child-menu if they are also active. and if so, remove the active class
                document
                    .querySelectorAll(".webx-grandchild-link")
                    .forEach((link) => {
                        //check if one is active, and remove. end the loop
                        if (link.classList.contains("active")) {
                            closed = true;
                            link.classList.remove("active");
                            return;
                        }
                    });
                //if no grandchild link was active, check if a child link was active
                if (!closed) {
                    document
                        .querySelectorAll(".webx-child-link")
                        .forEach((link) => {
                            if (link.classList.contains("active")) {
                                closed = true;
                                link.classList.remove("active");
                                return;
                            }
                        });
                }
                if (!closed) {
                    document
                        .querySelectorAll(".webx-full-screen-overlay")
                        .forEach((item) => {
                            if (item.classList.contains("active")) {
                                item.classList.remove("active");
                                closed = true;
                            }
                        });
                    //get .webx-close-wrapper.mobile and add class back-button
                    const backWrapper = document.querySelector(
                        ".webx-close-wrapper.mobile",
                    );
                    //if window width is above add back button
                    backWrapper.classList.remove("back-button");
                }
                //if no child link was active, close the menu
                if (!closed) {
                    //remove webx-fullscreen-nav-open class from body
                    document.body.classList.remove("webx-fullscreen-nav-open");
                    //remove visible from wp-block-webx-full-screen-menu
                    document
                        .querySelector(".wp-block-webx-blocks-full-screen-menu")
                        .classList.remove("visible");
                    //setting the isOpen to false
                    fullscreenNavigation.isOpen = false;
                }
            });
        });
});
